import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Planning module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab
 * (OTD lives there). No "coming soon" note. The route is gated by dept.planning.
 */
const MODULES = ["display", "tasks", "cr", "project", "epo", "dms", "kpi"];

const Planning = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-calendar-todo-line"
                        eyebrow="Operations"
                        title="Planning"
                        subtitle="Schedules, capacity, and forecasts"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Planning" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="planning" title="Planning modules" icon="ri-calendar-todo-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Planning;
